import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Star, User, LogOut, Settings, Menu, X } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const BADGE_COLORS = {
  "Food Novice": "badge-novice",
  "Food Explorer": "badge-explorer",
  "Food Connoisseur": "badge-connoisseur",
  "Prince Foody": "badge-prince",
  "Royal Foody": "badge-royal"
};

export const CommunityNav = ({ user, mobileMenuOpen, onMobileToggle, onLogout }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const links = [
    { path: "/dashboard", label: t('common.dashboard') },
    { path: "/restaurants", label: t('common.restaurants') },
    { path: "/preferences", label: t('common.preferences') },
    { path: "/community", label: t('common.community'), active: true },
    { path: "/leaderboard", label: t('common.leaderboard') },
  ];

  return (
    <nav className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/dashboard')}>
            <Star className="w-5 h-5 text-primary fill-primary" />
            <span className="font-semibold gradient-text">Étoile</span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <button
                key={link.path}
                onClick={() => navigate(link.path)}
                className={`menu-item text-sm py-2 ${link.active ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'}`}
              >
                {link.label}
              </button>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="flex items-center gap-2 h-10">
                  {user?.picture ? (
                    <img src={user.picture} alt="" className="w-8 h-8 rounded-full" />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                      <User className="w-4 h-4 text-primary" />
                    </div>
                  )}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48 bg-popover border-border">
                <DropdownMenuItem onClick={() => navigate('/profile')} className="cursor-pointer">
                  <Settings className="w-4 h-4 mr-2" />{t('common.profile')}
                </DropdownMenuItem>
                <DropdownMenuSeparator className="bg-muted/50" />
                <DropdownMenuItem onClick={onLogout} className="cursor-pointer text-destructive">
                  <LogOut className="w-4 h-4 mr-2" />{t('common.logout')}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>

          <button className="md:hidden p-2" onClick={onMobileToggle}>
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-border">
            <div className="flex flex-col gap-2">
              {links.map((link) => (
                <button
                  key={link.path}
                  onClick={() => { navigate(link.path); onMobileToggle(); }}
                  className={`text-left py-2 ${link.active ? 'text-foreground' : 'text-muted-foreground'}`}
                >
                  {link.label}
                </button>
              ))}
              <button onClick={() => { navigate('/profile'); onMobileToggle(); }} className="text-left py-2 text-muted-foreground">{t('common.profile')}</button>
              <button onClick={onLogout} className="text-left py-2 text-destructive">{t('common.logout')}</button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
